import PropTypes from 'prop-types';
import React from 'react';
import SearchField from '../../../../common/components/controls/base/SearchField/SearchField';

import FilterBar from '../../../../common/components/controls/FilterBar';
import propTypes from '../../../../common/propTypes';
import Statuses from '../../../../model/Statuses';
import translatePropTypes from '../../../translatePropTypes';
import withTranslations from '../../utils/Translations/withTranslations';

@withTranslations
export default class StaticTreeDefaultFilter extends React.PureComponent {
  static propTypes = {
    value: PropTypes.shape({
      status: PropTypes.oneOfType([
        PropTypes.oneOf(propTypes.statuses),
        PropTypes.oneOf(propTypes.statusesWithDraft),
      ]),
      searchQuery: PropTypes.string.isRequired,
    }).isRequired,
    onChange: PropTypes.func,
    hasSearchFieldOnly: PropTypes.bool,
    hasOmitDeleteStatus: PropTypes.bool,
    hasDraftStatus: PropTypes.bool,
    searchFieldWidthClassName: PropTypes.string,
    ...translatePropTypes,
  };

  static defaultProps = {
    hasSearchFieldOnly: false,
    onChange: null,
    hasOmitDeleteStatus: false,
    hasDraftStatus: false,
    searchFieldWidthClassName: undefined,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: this.props.value.searchQuery,
    };
  }

  handleChange = filters => {
    const { value, onChange } = this.props;
    onChange && onChange({ ...value, ...filters });
  };

  handleSearchChange = searchQuery => {
    const { hasSearchFieldOnly } = this.props;

    this.setState({ searchQuery });

    if (hasSearchFieldOnly) {
      const { value, onChange } = this.props;
      onChange && onChange({ ...value, searchQuery });
    }
  };

  handleSearchInputFocus = searchContainerInput => {
    if (!searchContainerInput) {
      return;
    }

    const input = searchContainerInput.getElementsByTagName('input')[0];
    input && input.focus();
  };

  render() {
    const {
      value,
      hasSearchFieldOnly,
      hasOmitDeleteStatus,
      hasDraftStatus,
      searchFieldWidthClassName,
      t,
    } = this.props;
    const { searchQuery } = this.state;

    const searchField = (
      <div ref={this.handleSearchInputFocus}>
        <SearchField
          placeholder={t('Search')}
          value={searchQuery}
          widthClassName={searchFieldWidthClassName}
          onChange={this.handleSearchChange}
        />
      </div>
    );

    if (hasSearchFieldOnly) {
      return searchField;
    }

    return (
      <>
        <FilterBar
          searchName="searchQuery"
          values={{
            status: value.status || Statuses.Active.value,
            searchQuery,
          }}
          onChange={this.handleChange}
        >
          {hasDraftStatus ? (
            <FilterBar.StatusWithDraftSelector
              hasOmitDeleteStatus={hasOmitDeleteStatus}
              name="status"
            />
          ) : (
            <FilterBar.StatusSelector
              hasOmitDeleteStatus={hasOmitDeleteStatus}
              name="status"
            />
          )}
        </FilterBar>

        {searchField}
      </>
    );
  }
}
